module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-categories/kiosk-categories.component.css
// module id = ./src/app/kiosk-categories/kiosk-categories.component.css
// module chunks = main